angular.module('impactx.lot').controller('LotSubSupplierListCtrl', LotSubSupplierListCtrl);
LotSubSupplierListCtrl.$inject = ['$routeParams', 'selectedListItems', 'BackService', 'BackFactory'];

function LotSubSupplierListCtrl($routeParams, selectedListItems, BackService, BackFactory) {
    var ctrl = this;

    this.getDetailLink = function () {
        if (selectedListItems.getFirstSelectedItem()) {
            return "lotsubsupplierdetail/" + selectedListItems.getFirstSelectedItem().id + "/" + selectedListItems.getFirstSelectedItem().lotSupplierId;
        }
        return "";
    };

    this.backFunction = function () {
        BackFactory.setLotSupplierId($routeParams.lotId);
        BackService.back();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewLotSubSupplier'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/lot/templates/lotsubsupplierlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/lot/subsupplierlist',
        id: "lotsubsupplierlist",
        valuesInteger: [{name: "LOTSUPPLIER_Id", value: $routeParams.lotSupplierId}],
        mainAction: {id: "new", link: "#/lotsubsupplierdetail/0/" + $routeParams.lotSupplierId + "/", icon: "mdi-plus"},
        backFunction: ctrl.backFunction
    };

    this.getMeta = function () {
        return this.meta;
    };
}